import React from 'react';
import Grid from '@mui/material/Grid';
import Skeleton from '@mui/material/Skeleton';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Avatar from '../../../../avatar/Avatar';
import AvatarSkeleton from '../../../../avatar/AvatarSkeleton';

const PhotoManagementGrid = ({ list, isLoadingList }) => {
  return (
      <div className='px-1 py-2'>
        <Grid container spacing={1} justifyContent='start'>
          {isLoadingList &&
            [...Array(5).keys()].map((index) => (
              <Grid item key={`row-grid-loading-${index}`}>
                <AvatarSkeleton size='xlarge' variant='square' />
                <div
                  className='h-14 px-2 flex justify-between items-center'
                  style={{ width: 'calc(160px - 1rem)' }}
                >
                  <Skeleton variant='text' width={100} />
                  <Skeleton variant='text' width={20} />
                </div>
              </Grid>
            ))}
          {!isLoadingList &&
            list.map((row, index) => (
              <Grid item key={`row-list-class-${row._id}-${index}`}>
                <Card>
                  <CardContent className='' style={{ padding: 0 }}>
                    <Avatar size='xlarge' variant='square' alt={row.name} src={`photos/${row?.fullName}`} />
                    <div
                      className='h-14 px-2 flex justify-between items-center'
                      style={{ width: 'calc(160px - 1rem)' }}
                    >
                      <Typography variant='' className='text-center text-primary text-ellipsis pl-2'>
                        {row.userCode}
                      </Typography>
                      {row.deleted}
                    </div>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          {!isLoadingList && list.length === 0 && (
            <Grid item xs={12}>
              <Typography className='text-center text-muted-foreground opacity-50'>
                You don't have any photo yet
              </Typography>
            </Grid>
          )}
        </Grid>
      </div>
  );
};

export default PhotoManagementGrid;
